import { Component, Input } from '@angular/core';

@Component({
  selector: 'mm-expandable-panel',
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss']
})
export class ExpandablePanelComponent {

  @Input() header: string = '';
  @Input() content: string = '';

  isExpanded = false;

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
